import { EventEmitter, Injectable } from '@angular/core';
import { ProductSearchResultDto } from '@scip/api';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductTableService {
  selectionChanged = new ReplaySubject<ProductSearchResultDto[]>(1);
  refreshProductsTable: EventEmitter<void> = new EventEmitter();

  setProducts(selection: ProductSearchResultDto[]): void {
    this.selectionChanged.next(selection);
  }

  triggerRefreshProductsTable(): void {
    this.refreshProductsTable.emit();
  }
}
